export default __webpack_public_path__ + "static/media/PAVAN_HIREMATH.0bc64e66.JPG";